import { http } from '@/core/api/';

// Servicio Orquestador del Asistente de IA (US 156983) — backend ya construido:
// EduEsp.Web.Api/Controllers/PeiAIOrchestratorController.cs

const apiUrl = 'api/pei/aiorchestrator';

/**
 * Genera una sugerencia de redacción para una sección/campo del PEI.
 * @param {{ module: string, sectionArea: string, campo?: string, peiId: string }} payload
 */
export const generateSuggestion = (payload) => {
  // skipLoading: el modal del asistente tiene su propio spinner (aiModal.loading) --
  // sin esto, el interceptor de axios también dispara el loading de pantalla completa.
  return http.post(`${apiUrl}/generate`, payload, { headers: { skipLoading: true } });
};

/**
 * Refina una sugerencia ya generada, a partir de una instrucción libre del especialista.
 * Reutiliza el mismo contexto congelado de la corrida original (ver PeiAIOrchestratorEngine.RefineSuggestionAsync).
 * @param {{ aiGenerationLogId: number, teacherInstruction: string }} payload
 */
export const refineSuggestion = (payload) => {
  return http.post(`${apiUrl}/refine`, payload, { headers: { skipLoading: true } });
};

/**
 * Modo de Prueba (25 ago 2026, Consola de Instrucciones IA): corre el mismo flujo de
 * generateSuggestion pero con lo que está ESCRITO EN PANTALLA en ese momento (guardado o no),
 * contra un PEI real. aiPromptConfigurationId debe apuntar a una fila YA GUARDADA -- se usa
 * solo como ancla de auditoría (ver PeiAITestPromptRequest.AIPromptConfigurationId), nunca
 * como fuente del contenido probado.
 * @param {{ aiPromptConfigurationId: number, peiId: string, systemMessageText: string,
 *   promptText: string, sources?: string[], maxTokens?: number, temperature?: number,
 *   topP?: number, responseJsonSchema?: string, responseJsonSchemaName?: string,
 *   enumSourcesJson?: string }} payload
 */
export const testPrompt = (payload) => {
  return http.post(`${apiUrl}/test`, payload, { headers: { skipLoading: true } });
};

/**
 * Marca que ESTA corrida (no otra que el especialista pudo haber visto/regenerado/refinado
 * antes) fue la sugerencia que realmente se aplicó -- sin esto, LOG_AiGeneration permite
 * reconstruir la cadena de refinamientos pero no cuál, si alguna, se aceptó.
 * @param {{ aiGenerationLogId: number }} payload
 */
export const markSuggestionUsed = (payload) => {
  return http.post(`${apiUrl}/accept`, payload, { headers: { skipLoading: true } });
};

/**
 * Registra si la sugerencia le fue útil o no al especialista. Nota: "aceptada" (usar/insertar)
 * y "le gustó" son señales distintas -- un especialista puede aceptar una sugerencia mediocre
 * por cansancio, o refinar varias veces antes de encontrar la que de verdad le sirvió -- por
 * eso este feedback es explícito y separado de markSuggestionUsed.
 * @param {{ aiGenerationLogId: number, liked: boolean }} payload
 */
export const submitFeedback = (payload) => {
  return http.post(`${apiUrl}/feedback`, payload, { headers: { skipLoading: true } });
};
